export default {"src":"/_next/static/media/card-back-icon.0d3ae1bc.svg","height":18,"width":24};